(function () {
  'use strict';

  function initReveal() {
    var revealEls = document.querySelectorAll('.ies-reveal');
    if (!revealEls.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      revealEls.forEach(function (el) {
        io.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }

  function initCounters() {
    var counters = document.querySelectorAll('.ies-metric-num[data-count]');
    if (!counters.length) return;

    function animateCounter(el) {
      var target = parseInt(el.getAttribute('data-count'), 10);
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1400;
      var startTime = null;

      function step(ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = Math.floor(eased * target);
        el.textContent = value.toLocaleString() + suffix;
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = target.toLocaleString() + suffix;
        }
      }

      requestAnimationFrame(step);
    }

    if ('IntersectionObserver' in window) {
      var counterIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateCounter(entry.target);
              counterIo.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.5 }
      );
      counters.forEach(function (el) {
        counterIo.observe(el);
      });
    } else {
      counters.forEach(function (el) {
        el.textContent =
          el.getAttribute('data-count') + (el.getAttribute('data-suffix') || '');
      });
    }
  }

  function initStaticMetrics() {
    document.querySelectorAll('.ies-metric-num[data-static]').forEach(function (el) {
      el.textContent = el.getAttribute('data-static');
    });
  }

  function initFaq() {
    document.querySelectorAll('.ies-faq-question').forEach(function (btn) {
      if (btn.dataset.iesBound) return;
      btn.dataset.iesBound = 'true';

      btn.addEventListener('click', function () {
        var item = btn.closest('.ies-faq-item');
        var answer = item.querySelector('.ies-faq-answer');
        var isOpen = item.classList.contains('is-open');

        document.querySelectorAll('.ies-faq-item.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            openItem.querySelector('.ies-faq-answer').style.maxHeight = null;
            openItem.querySelector('.ies-faq-question').setAttribute('aria-expanded', 'false');
          }
        });

        if (isOpen) {
          item.classList.remove('is-open');
          answer.style.maxHeight = null;
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initFinalCtaScroll() {
    document.querySelectorAll('[data-ies-scroll-to-hero]').forEach(function (btn) {
      if (btn.dataset.iesBound) return;
      btn.dataset.iesBound = 'true';

      btn.addEventListener('click', function () {
        var hero = document.querySelector('.ies-hero-section');
        var email = document.querySelector('.ies-hero-section input[type="email"]');
        if (hero) {
          hero.scrollIntoView({ behavior: 'smooth' });
        }
        if (email) {
          setTimeout(function () {
            email.focus();
          }, 400);
        }
      });
    });
  }

  function init() {
    initReveal();
    initCounters();
    initStaticMetrics();
    initFaq();
    initFinalCtaScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
